import React from "react";

const PriceChanges = () => {
  return <div>PriceChanges</div>;
};

export default PriceChanges;
